import add from 'assets/images/add.svg';
import { defaultStyles, imagesUrl } from 'library';
import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    button: {
        fontSize: '14px',
        padding: '13px',
        textAlign: 'center',
        textDecoration: 'none',
        textTransform: 'uppercase',
        fontWeight: 'bold',
        display: 'inline-block',
        color: defaultStyles.blue,
        backgroundColor: defaultStyles.white,
        border: '2px solid ' + defaultStyles.blue,
        transition: 'ease .2s',
        verticalAlign: 'middle',
        cursor: 'pointer',
        userSelect: 'none',


        ':hover': {
            backgroundColor: defaultStyles.white,
            borderColor: defaultStyles.yellow,
            color: defaultStyles.yellow,
        },
    },
    addIcon: {
        ':before': {
            content: '\'\'',
            display: 'inline-block',
            verticalAlign: 'middle',
            marginRight: '10px',
            width: '28px',
            height: '28px',
        }
    },
    addIconInt: {
        ':before': {
            background: 'transparent url('+ imagesUrl.int + add +') center center no-repeat',
        }
    },
    addIconQual: {
        ':before': {
            background: 'transparent url('+ imagesUrl.qual + add +') center center no-repeat',
        }
    },
    addIconProd: {
        ':before': {
            background: 'transparent url('+ imagesUrl.prod + add +') center center no-repeat',
        }
    },
    addIconlocal: {
        ':before': {
            background: 'transparent url('+ imagesUrl.local + add +') center center no-repeat',
        }
    },
    primary: {
        backgroundColor: defaultStyles.blue,
        border: '1px solid ' + defaultStyles.blue,
        color: defaultStyles.white,
        ':hover': {
            backgroundColor: defaultStyles.yellow,
            borderColor: defaultStyles.yellow,
            color: defaultStyles.white,
        }
    },
    transparent: {
        backgroundColor: defaultStyles.transparent,
        border: '2px solid ' + defaultStyles.white,
        color: defaultStyles.white,
        ':hover': {
            backgroundColor: defaultStyles.yellow,
            borderColor: defaultStyles.yellow,
            color: defaultStyles.white,
        }
    },
    block: {
        display: 'block',
    },
    span: {
        display: 'inline-block',
        verticalAlign: 'middle'
    },
    disabled: {
        padding: '0.8rem 2rem',
        textDecoration: 'none',
        textTransform: 'uppercase',
        fontWeight: '700',
        lineHeight: '1.5rem',
        display: 'inline-block',
        color: defaultStyles.white,
        backgroundColor: defaultStyles.greyMedium,
        verticalAlign: 'middle',
        cursor: 'not-allowed',
        pointerEvents: 'none',
        borderColor: defaultStyles.greyMedium,
        ':hover': {
            color: defaultStyles.white,
            backgroundColor: defaultStyles.greyMedium,
            borderColor: defaultStyles.greyMedium,
        }
    },
    inactiveText: {
        marginTop: '16px',
    }
});

export default styles;